import type {
  DashboardStats,
  DashboardHealth,
  DashboardFunnel,
  TransferState,
} from './types'
import api from '.'

export async function getStats(): Promise<DashboardStats> {
  const res = await api.get<DashboardStats>('/stats')
  return res.data
}

export async function getHealth(): Promise<DashboardHealth> {
  const res = await api.get<DashboardHealth>('/health')
  return res.data
}

export async function getFunnel(): Promise<DashboardFunnel> {
  const res = await api.get<DashboardFunnel>('/funnel')
  return res.data
}

export async function getTransfers(): Promise<TransferState> {
  const res = await api.get<TransferState>('/transfers')
  return res.data
}

export async function toggleTransfers(): Promise<TransferState> {
  const res = await api.post<TransferState>('/transfers/toggle')
  return res.data
}
